export const fistFormRules = {
  createBy: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageVariety: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageName: [{ required: true, message: '必填字段' }],
  storageCompanyObj: [{ required: true, message: '必填字段' }],
  isReality: [{ required: true, message: '必填字段', trigger: 'blur' }],
};

export const batchGenerateRules = {
  prefix: [{ required: true, message: '必填字段', trigger: 'blur' }],
  startNum: [{ required: true, message: '必填字段', trigger: 'blur' }],
  endNum: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageVariety: [{ required: true, message: '必填字段', trigger: 'blur' }],
};
